// You can write more code here

import { ShopTabController } from '@/game/prefabs/CosmeticShop/ShopTabController';

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ShopTab extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // tabBacking
    const tabBacking = scene.add.nineslice(
      0,
      0,
      'shop-tab',
      undefined,
      40,
      16,
      4,
      4,
      4,
      8,
    );
    tabBacking.scaleX = 4;
    tabBacking.scaleY = 4;
    tabBacking.setOrigin(0, 0);
    this.add(tabBacking);

    // tabTitle
    const tabTitle = scene.add.bitmapText(50, 28, 'Aronui', 'Hats');
    tabTitle.setOrigin(0, 0.5);
    tabTitle.tintTopLeft = 5387071;
    tabTitle.tintTopRight = 5387071;
    tabTitle.tintBottomLeft = 5387071;
    tabTitle.tintBottomRight = 5387071;
    tabTitle.text = 'Hats';
    tabTitle.fontSize = -20;
    this.add(tabTitle);

    // tabImage
    const tabImage = scene.add.image(26, 28, 'hattab');
    tabImage.scaleX = 1.25;
    tabImage.scaleY = 1.25;
    this.add(tabImage);

    // shopTabNotification
    const shopTabNotification = scene.add.image(128, 28, 'hud-icons', 240);
    shopTabNotification.scaleX = 2;
    shopTabNotification.scaleY = 2;
    this.add(shopTabNotification);

    // disabledCover
    const disabledCover = scene.add.nineslice(
      0,
      0,
      'shop-tab',
      undefined,
      40,
      16,
      4,
      4,
      4,
      4,
    );
    disabledCover.scaleX = 4;
    disabledCover.scaleY = 4;
    disabledCover.setOrigin(0, 0);
    disabledCover.alpha = 0.3;
    disabledCover.tint = 985612;
    this.add(disabledCover);

    this.tabBacking = tabBacking;
    this.tabTitle = tabTitle;
    this.tabImage = tabImage;
    this.shopTabNotification = shopTabNotification;
    this.disabledCover = disabledCover;

    /* START-USER-CTR-CODE */

    this._controller = new ShopTabController(this);

    /* END-USER-CTR-CODE */
  }

  public tabBacking: Phaser.GameObjects.NineSlice;
  public tabTitle: Phaser.GameObjects.BitmapText;
  public tabImage: Phaser.GameObjects.Image;
  public shopTabNotification: Phaser.GameObjects.Image;
  public disabledCover: Phaser.GameObjects.NineSlice;

  /* START-USER-CODE */

  private _controller: ShopTabController;
  get controller() {
    return this._controller;
  }
  public defaultBackingTex: string = `shop-tab`;
  public hoverBackingTex: string = `shop-tab-hover`;
  public selectedBackingTex: string = `shop-tab-selected`;

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
